import { Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@ace-clublabs/shared-component-library';
import appStoreLogo from '../../assets/aaa-app-logo.svg';
import appStoreQR from '../../assets/app-download-qr.png';

interface IDownloadAppSection {
  completeRegistration?: boolean;
}

export const DownloadAppSection = ({ completeRegistration }: IDownloadAppSection) => {
  const theme = useTheme();
  const isMobileScreenSize = useMediaQuery(theme.breakpoints.down('md'));

  const userAgent = navigator.userAgent || '';
  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;

  let appStoreLink;
  if (isAndroid) {
    appStoreLink =
      'https://play.google.com/store/apps/details?id=com.ace.shell.production&referrer=utm_source%3DACE%26utm_campaign%3DAuto_Club_App_Landing';
  } else if (isIOS) {
    appStoreLink = 'https://apps.apple.com/app/apple-store/id1094393125?pt=205244';
  } else {
    appStoreLink = 'https://www.ace.aaa.com/automotive/driver-resources/auto-club-app.html';
  }

  return (
    <div hidden={completeRegistration} className="download-app-container" id="downloadAppContainer">
      <Paper
        sx={{
          backgroundColor: '#F5F7FA',
          padding: '1rem',
          borderRadius: '0.5rem',
        }}
      >
        <Stack direction="row">
          <Stack className="download-app-text">
            <Typography variant="b2Medium">Get more with the Auto Club App</Typography>
            <Typography variant="b2Regular" marginTop="0.25rem">
              {isMobileScreenSize ? (
                <Link
                  id="downloadAppLink"
                  className="download-app-link"
                  href={appStoreLink}
                  target="_blank"
                  variant="b2Regular"
                  sx={{
                    color: '#0156A3',
                    textDecorationColor: '#0156A3',
                    '&:hover': {
                      cursor: 'pointer',
                    },
                  }}
                >
                  Download the app
                </Link>
              ) : (
                'Download the app'
              )}{' '}
              to manage your membership, insurance, and enjoy everyday discounts.
            </Typography>
          </Stack>
          <img
            src={isMobileScreenSize ? appStoreLogo : appStoreQR}
            alt="aaa-app-logo"
            className="aaa-app-logo"
            style={{
              maxWidth: isMobileScreenSize ? '4rem' : '5rem',
              backgroundColor: isMobileScreenSize ? 'transparent' : '#fff',
              borderRadius: '0.5rem',
            }}
          />
        </Stack>
      </Paper>
    </div>
  );
};
